import { useMemo } from 'react';
import styled from 'styled-components';
import { Small } from 'foundations-components/transitional/components/Small';
import { TruncateString } from 'foundations-components/transitional/components/TruncateString';
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ClickableTd = styled.td.withConfig({
  displayName: "CellWithHelpText__ClickableTd",
  componentId: "tsvb6v-0"
})(["cursor:pointer;"]);
const ClickableDiv = styled.div.withConfig({
  displayName: "CellWithHelpText__ClickableDiv",
  componentId: "tsvb6v-1"
})(["cursor:pointer;"]);
const HelpText = ({
  helpText,
  truncateHelpText
}) => {
  if (!truncateHelpText) {
    return /*#__PURE__*/_jsx(_Fragment, {
      children: helpText
    });
  }
  if (!helpText) {
    return null;
  }
  return /*#__PURE__*/_jsx(TruncateString, {
    children: helpText
  });
};
const MainText = ({
  text,
  truncateMainText,
  ariaLabel
}) => {
  if (!truncateMainText) {
    return /*#__PURE__*/_jsx(_Fragment, {
      children: text
    });
  }
  if (!text) {
    return null;
  }
  return /*#__PURE__*/_jsx(TruncateString, {
    "aria-hidden": ariaLabel ? true : undefined,
    children: text
  });
};
const CellWithHelpText = ({
  ariaLabel,
  helpText,
  isCell,
  text,
  truncateHelpText,
  truncateMainText,
  onClick
}) => {
  const handleClick = e => {
    if (e.target.nodeName !== 'A' && onClick) {
      onClick(e);
    }
  };
  const Container = useMemo(() => {
    if (onClick) {
      return isCell ? ClickableTd : ClickableDiv;
    }
    return isCell ? 'td' : 'div';
  }, [isCell, onClick]);
  return /*#__PURE__*/_jsx(Container, {
    onClick: handleClick,
    children: /*#__PURE__*/_jsxs("div", {
      "aria-label": ariaLabel || undefined,
      children: [/*#__PURE__*/_jsx(MainText, {
        text: text,
        ariaLabel: ariaLabel,
        truncateMainText: truncateMainText
      }), /*#__PURE__*/_jsx(Small, {
        use: "help",
        "aria-hidden": ariaLabel ? true : undefined,
        children: /*#__PURE__*/_jsx(HelpText, {
          helpText: helpText,
          truncateHelpText: truncateHelpText
        })
      })]
    })
  });
};
export default CellWithHelpText;